/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClaimAttributionRequestToJSON, ClaimAttributionResponseFromJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class AttributionApi extends runtime.BaseAPI {
    /**
     * Claim a tracked visit\'s acquisition signals onto the authenticated user.  Write-once: succeeds only while the user\'s current acquisition is still \"unknown\" (409 otherwise). An unknown or expired visit_token returns 404 and leaves the user\'s acquisition unchanged.  Args:     request: The visit_token to claim.     user: The authenticated user.     db: Firestore client.  Returns:     ClaimAttributionResponse: The resulting acquisition record.
     * Claim Attribution
     */
    async claimAttributionV1AttributionClaimPostRaw(requestParameters, initOverrides) {
        if (requestParameters['claimAttributionRequest'] == null) {
            throw new runtime.RequiredError('claimAttributionRequest', 'Required parameter "claimAttributionRequest" was null or undefined when calling claimAttributionV1AttributionClaimPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/attribution/claim`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClaimAttributionRequestToJSON(requestParameters['claimAttributionRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimAttributionResponseFromJSON(jsonValue));
    }
    /**
     * Claim a tracked visit\'s acquisition signals onto the authenticated user.  Write-once: succeeds only while the user\'s current acquisition is still \"unknown\" (409 otherwise). An unknown or expired visit_token returns 404 and leaves the user\'s acquisition unchanged.  Args:     request: The visit_token to claim.     user: The authenticated user.     db: Firestore client.  Returns:     ClaimAttributionResponse: The resulting acquisition record.
     * Claim Attribution
     */
    async claimAttributionV1AttributionClaimPost(requestParameters, initOverrides) {
        const response = await this.claimAttributionV1AttributionClaimPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
